export default {
  path: 'taskdetail',
  name:'taskdetail',
  component: () => import(/* webpackChunkName: "sys_log-list" */ '@/pages/customer/Taskdetail'),
  meta: {title:'任务审核详情',cate:'任务详情中心'}
}